export default "__VITE_ASSET__DlowlcKm__"